import Button from "./Button/Button";
import "./filterFolder.css";
import msgIcon from "./images/1.png";
import cancelIcon from "./images/Cancel.png";
import wwwIcon from "./images/7.png";
import documentIcon from "./images/dokument.png";
import imgIcon from "./images/8.png";

const FilterFolder = ({
  file,
  index,
  showingItems,
  setShowingItems,
  sortingChecked,
  aspectRatio,
}) => {
  const {
    id,
    title,
    timeCreated,
    timeModified,
    comments,
    documents,
    links,
    images,
  } = file;

  const correctDate = (date) => {
    if (date !== null) {
      const left = date.split(" ")[0];
      const correctOnes = left.split("-");
      return `${correctOnes[2]}.${correctOnes[1]}`;
    }
  };

  const handleMessageActive = (id) => {
    const newShowingItems = showingItems.map((itemmsg, indexmsg) => {
      if (indexmsg === id) {
        return { ...itemmsg, commentActive: !itemmsg.commentActive };
      } else return itemmsg;
    });

    console.log(showingItems);
    console.log(newShowingItems);
    setShowingItems(newShowingItems);
  };

  const handleDocumentActive = (id) => {
    const newShowingItems = showingItems.map((itemdoc, indexdoc) => {
      if (indexdoc === id) {
        return { ...itemdoc, documentActive: !itemdoc.documentActive };
      } else return itemdoc;
    });
    setShowingItems(newShowingItems);
  };

  const handleLinkActive = (id) => {
    console.log(id);
    const newShowingItems = showingItems.map((itemlink, indexlink) => {
      if (indexlink === id) {
        return { ...itemlink, linkActive: !itemlink.linkActive };
      } else return itemlink;
    });
    console.log(newShowingItems);
    setShowingItems(newShowingItems);
  };

  const handleImageActive = (id) => {
    const newShowingItems = showingItems.map((itemimage, idimage) => {
      if (idimage === id) {
        return { ...itemimage, imgActive: !itemimage.imgActive };
      } else return itemimage;
    });
    setShowingItems(newShowingItems);
  };

  const setColor = (value) => {
    console.log(showingItems[index].msgActive);
    if (value) return "red";
    else return "gray";
  };

  return (
    <div className={aspectRatio ? "filter-folder" : "filter-folder-portrait"}>
      <div className="filter-folder-left">
        <div className="filter-folder-left-top">
          <span className="number">
            {sortingChecked ? showingItems.length - index - 1 : index}.
          </span>
          <span className="name">{title}</span>
          <span className="date">{correctDate(timeCreated)}</span>
        </div>
        <span className="filter-folder-left-middle">
          {correctDate(timeModified)}
        </span>
        <div className="filter-folder-left-bottom">
          <img src={msgIcon} alt="" />
          <span>{comments.length}</span>
        </div>
      </div>
      <div className="filter-folder-right">
        <div
          className={
            aspectRatio ? "filter-folder-btn" : "filter-folder-btn-portrait"
          }
        >
          <Button image={cancelIcon}></Button>
        </div>
        <div
          className={
            aspectRatio ? "filter-folder-btn" : "filter-folder-btn-portrait"
          }
          onClick={() => handleMessageActive(index)}
        >
          <Button activation={true}>
            <div
              className={`button-div ${setColor(
                showingItems[index].commentActive
              )}`}
            >
              <img src={msgIcon} alt="" />
            </div>
          </Button>
          <div className="circle">{comments.length}</div>
        </div>
        <div
          className={
            aspectRatio ? "filter-folder-btn" : "filter-folder-btn-portrait"
          }
          onClick={() => handleLinkActive(index)}
        >
          <Button activation={true}>
            <div
              className={`button-div ${setColor(
                showingItems[index].linkActive
              )}`}
            >
              <img src={wwwIcon} alt="" />
            </div>
          </Button>
          <div className="circle">{links.length}</div>
        </div>
        <div
          className={
            aspectRatio ? "filter-folder-btn" : "filter-folder-btn-portrait"
          }
          onClick={() => handleDocumentActive(index)}
        >
          <Button activation={true}>
            <div
              className={`button-div ${setColor(
                showingItems[index].documentActive
              )}`}
            >
              <img src={documentIcon} alt="" />
            </div>
          </Button>
          <div className="circle">{documents.length}</div>
        </div>
        <div
          className={
            aspectRatio ? "filter-folder-btn" : "filter-folder-btn-portrait"
          }
          onClick={() => handleImageActive(index)}
        >
          <Button activation={true}>
            <div
              className={`button-div ${setColor(
                showingItems[index].imgActive
              )}`}
            >
              <img src={imgIcon} alt="" />
            </div>
          </Button>
          <div className="circle">{images.length}</div>
        </div>
      </div>
    </div>
  );
};

export default FilterFolder;
